const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const services = [
    { name: 'Climatisation', link: '/services/climatisation' },
    { name: 'Chauffage', link: '/services/chauffage' },
    { name: 'Plomberie', link: '/services/plomberie' },
    { name: 'Rénovation Salle de Bains', link: '/services/renovation-salle-de-bains' },
    { name: 'Dépannage Urgent', link: '/services/depannage-urgent' },
    { name: 'Entretien', link: '/services/entretien' }
  ];

  return (
    <footer className="bg-gradient-to-br from-teal-600 to-teal-700 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
          {/* Company Info */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-lg sm:text-xl font-bold mb-3 sm:mb-4">Ion Certan</h3>
            <p className="text-teal-100 text-xs sm:text-sm leading-relaxed mb-3 sm:mb-4">
              Plombier Chauffagiste et Sanitaire à Valence. Votre artisan de proximité pour tous vos travaux.
            </p>
            <div className="flex space-x-3">
              <a href="https://www.facebook.com/share/179dTdR6kt/" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-lg sm:text-xl"></i>
              </a>
              <a href="https://share.google/x829Qcv5lWqwB9kvA" target="_blank" rel="noopener noreferrer" className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-lg transition-colors cursor-pointer">
                <i className="ri-google-fill text-lg sm:text-xl"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-sm sm:text-lg font-bold mb-3 sm:mb-4">Nos Services</h3>
            <ul className="space-y-1.5 sm:space-y-2">
              {services.map((service, index) => (
                <li key={index}>
                  <a href={service.link} className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm cursor-pointer">
                    {service.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm sm:text-lg font-bold mb-3 sm:mb-4">Liens Rapides</h3>
            <ul className="space-y-1.5 sm:space-y-2">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('a-propos')} className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm">
                  À propos
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 md:col-span-1">
            <h3 className="text-sm sm:text-lg font-bold mb-3 sm:mb-4">Contact</h3>
            <ul className="space-y-2 sm:space-y-3">
              <li className="flex items-start">
                <i className="ri-phone-line text-teal-200 mt-0.5 mr-2 sm:mr-3 flex-shrink-0"></i>
                <a href="tel:0760705475" className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm">
                  07 60 70 54 75
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-mail-line text-teal-200 mt-0.5 mr-2 sm:mr-3 flex-shrink-0"></i>
                <a href="mailto:ioncertanpro@gmail.com" className="text-teal-100 hover:text-white transition-colors text-xs sm:text-sm break-all">
                  ioncertanpro@gmail.com
                </a>
              </li>
              <li className="flex items-start">
                <i className="ri-map-pin-line text-teal-200 mt-0.5 mr-2 sm:mr-3 flex-shrink-0"></i>
                <span className="text-teal-100 text-xs sm:text-sm">
                  Valence et alentours
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-teal-500 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center">
          <p className="text-teal-100 text-xs sm:text-sm">
            © {new Date().getFullYear()} Ion Certan - Plombier Chauffagiste Valence. Tous droits réservés.
          </p>
          <p className="text-teal-200/70 text-xs mt-1.5 sm:mt-2">
            Site créé et propulsé par Stas —{' '}
            <a href="tel:+33767117948" className="hover:text-white transition-colors">
              07 67 11 79 48
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
